import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
    title = 'ATAM Connect | Singapore Indian Heritage & Arts Events',
    description = 'Discover Singapore\'s Indian Heritage and Arts events, workshops, and performances. ATAM Connect brings together cultural experiences celebrating Indian and multicultural traditions across Singapore.',
    keywords = 'ATAM, Singapore Indian events, Indian Heritage events, Indian heritage Singapore, arts events Singapore, cultural workshops, Indian performances, Singapore arts, multicultural events, traditional arts',
    image = '/atam-logo.svg',
    url = window.location.href,
    type = 'website'
}) => {
    const siteTitle = 'ATAM Connect';
    const fullTitle = title.includes(siteTitle) ? title : `${title} | ${siteTitle}`;

    return (
        <Helmet>
            {/* Primary Meta Tags */}
            <title>{fullTitle}</title>
            <meta name="title" content={fullTitle} />
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta property="og:site_name" content={siteTitle} />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={url} />
            <meta property="twitter:title" content={fullTitle} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content={image} />

            {/* Additional Meta Tags */}
            <meta name="robots" content="index, follow" />
            <meta name="language" content="English" />
            <meta name="author" content="ATAM Connect" />
            <link rel="canonical" href={url} />
        </Helmet>
    );
};

export default SEO;
